<mat-toolbar color="accent">
  <span>{{ data.title || 'Book a meeting' }}</span>
  <span class="flex-1"></span>
  <button
    type="button"
    mat-icon-button
    mat-dialog-close
    aria-label="Close booking dialog"
  >
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  @if (loadError()) {
    <div
      class="flex min-h-full w-full min-w-[320px] flex-1 flex-col items-center justify-center gap-2 p-6 text-center"
    >
      <mat-icon color="warn">error_outline</mat-icon>
      <p>
        We couldn't load the booking widget. Please check your connection and
        try again.
      </p>
    </div>
  }
  <div
    #embedContainer
    class="flex min-h-full w-full min-w-[320px] flex-1 flex-col [&>iframe]:flex-1"
    [class.hidden]="loadError()"
  ></div>
</mat-dialog-content>
